import React, { useState } from "react";
import "../components/Table/Table.css";
import "./Leaves.css";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";

const MyLeaves = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [partialDays, setPartialDays] = useState('None');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [totalDuration, setTotalDuration] = useState(0);
  const [startDayDuration, setStartDayDuration] = useState('');
  const [endDayDuration, setEndDayDuration] = useState('');
  const { t } = useTranslation();

  const handlePartialDaysChange = (e) => {
    setPartialDays(e.target.value);
    calculateTotalDuration(fromDate, toDate, e.target.value, startDayDuration, endDayDuration);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'fromDate') {
      setFromDate(value);
      calculateTotalDuration(value, toDate, partialDays, startDayDuration, endDayDuration);
    } else if (name === 'toDate') {
      setToDate(value);
      calculateTotalDuration(fromDate, value, partialDays, startDayDuration, endDayDuration);
    }
  };

  const handleStartDayDurationChange = (e) => {
    setStartDayDuration(e.target.value);
    calculateTotalDuration(fromDate, toDate, partialDays, e.target.value, endDayDuration);
  };

  const handleEndDayDurationChange = (e) => {
    setEndDayDuration(e.target.value);
    calculateTotalDuration(fromDate, toDate, partialDays, startDayDuration, e.target.value);
  };

  const calculateTotalDuration = (from, to, partial, startDuration, endDuration) => {
    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      let duration = (toDate - fromDate) / (1000 * 60 * 60 * 24) + 1;

      if (partial === 'Start Day Only' || partial === 'End Day Only') {
        duration -= 0.5;
      } else if (partial === 'Start and End Day') {
        duration -= 1;
      } else if (partial === 'All Days') {
        duration -= 0.5 * duration;
      }

      setTotalDuration(duration);
    } else {
      setTotalDuration(0);
    }
  };
  const moreThanOneDay = fromDate && toDate && new Date(toDate) > new Date(fromDate);

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />

      
      <div className="px-0 px-md-3">
        <div className="my-3 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("My Leaves")}</h5>
        </div>
        <div className="container">
          <div className="leaves-box">
            <div className="leave-type me-4">
              <h2>18.00</h2>
              <p>ANNUAL LEAVES</p>
            </div>
            <div className="leave-type">
              <h2>4.00</h2>
              <p>MEDICAL LEAVES</p>
            </div>
          </div>

          <div className="my-4 col-12 d-flex justify-content-between align-items-center">
            <h5 className="">{t("Apply Leave/Holidays")}</h5>
          </div>

          <div className="form-row">
            <div className="col-3 ">
              <label className="form-label" htmlFor="fromDate">From Date*</label>
              <input 
                type="date"
                id="fromDate"
                name="fromDate"
                className="form-control"
                required
                onChange={handleDateChange}
              />
            </div>
            <div className="col-3 mx-4">
              <label className="form-label" htmlFor="toDate">To Date*</label>
              <input 
                type="date"
                id="toDate"
                name="toDate"
                className="form-control"
                required
                onChange={handleDateChange}
              />
            </div>
            <div className="col-3 ">
              <label className="form-label">Total Duration</label>
              <div>
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={`${totalDuration} Day(s)`}
                />
              </div>
            </div>
          </div>

          {moreThanOneDay && (
            <div className="form-row my-4">
              <div className="form-group">
                <label>Partial Days</label>
                <div className="btn-group d-flex" role="group" aria-label="Partial Days">
                  <input className="btn-check" type="radio" name="partialDays" id="none" value="None" checked={partialDays === 'None'} onChange={handlePartialDaysChange} />
                  <label className="btn btn-outline-secondary" htmlFor="none">None</label>

                  <input className="btn-check" type="radio" name="partialDays" id="allDays" value="All Days" checked={partialDays === 'All Days'} onChange={handlePartialDaysChange} />
                  <label className="btn btn-outline-secondary" htmlFor="allDays">All Days</label>

                  <input className="btn-check" type="radio" name="partialDays" id="startDayOnly" value="Start Day Only" checked={partialDays === 'Start Day Only'} onChange={handlePartialDaysChange} />
                  <label className="btn btn-outline-secondary" htmlFor="startDayOnly">Start Day Only</label>

                  <input className="btn-check" type="radio" name="partialDays" id="endDayOnly" value="End Day Only" checked={partialDays === 'End Day Only'} onChange={handlePartialDaysChange} />
                  <label className="btn btn-outline-secondary" htmlFor="endDayOnly">End Day Only</label>

                  <input className="btn-check" type="radio" name="partialDays" id="startEndDay" value="Start and End Day" checked={partialDays === 'Start and End Day'} onChange={handlePartialDaysChange} />
                  <label className="btn btn-outline-secondary" htmlFor="startEndDay">Start and End Day</label>
                </div>
              </div>
            </div>
          )}

          {partialDays === 'Start and End Day' && (
            <>
              <div className="form-row my-4">
                <div className="form-group">
                  <label htmlFor="startDayDuration" className="form-label">Start Day</label>
                  <select style={{ width: '25rem' }}
                    name="startDayDuration"
                    className="common-input form-select"
                    onChange={handleStartDayDurationChange}
                  >
                    <option value="Half Day Morning">Half Day Morning</option>
                    <option value="Half Day Afternoon">Half Day Afternoon</option>
                  </select>
                </div>
              </div>

              <div className="form-row my-4">
                <div className="form-group">
                  <label htmlFor="endDayDuration" className="form-label">End Day</label>
                  <select style={{ width: '25rem' }}
                    name="endDayDuration"
                    className="common-input form-select"
                    onChange={handleEndDayDurationChange}
                  >
                    <option value="Half Day Morning">Half Day Morning</option>
                    <option value="Half Day Afternoon">Half Day Afternoon</option>
                  </select>
                </div>
              </div>
            </>
          )}

          {(partialDays === 'All Days' || partialDays === 'Start Day Only' || partialDays === 'End Day Only') && partialDays !== 'Start and End Day' && (
            <div className="form-row my-4">
              <div className="form-group">
                <label htmlFor="duration" className="form-label">
                  {partialDays === 'All Days' ? 'Duration' : partialDays === 'Start Day Only' ? 'Start Day' : 'End Day'}
                </label>
                <select style={{ width: '25rem' }}
                  id="duration"
                  name="duration"
                  className="common-input form-select"
                  onChange={handleStartDayDurationChange}
                >
                  <option value="Half Day Morning">Half Day Morning</option>
                  <option value="Half Day Afternoon">Half Day Afternoon</option>
                </select>
              </div>
            </div>
          )}

          {/* <div className="form-row my-4">
            <div className="form-group">
              <label className="form-label">Total Duration</label>
              <div>
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={`${totalDuration} Day(s)`}
                />
              </div>
            </div>
          </div> */}

          <div className="form-row my-4">
            <div className="form-group">
              <label htmlFor="comments" className="form-label">Comments</label>
              <textarea style={{ width: "50rem" }}
                name="comments"
                className="form-control"
                rows="4"
                placeholder="Enter your comment here..."
              ></textarea>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-12 d-flex justify-content-end">
              <button type="button" className="btn btn-secondary me-2">
                Clear
              </button>
              <button type="submit" className="btn btn-primary">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyLeaves;
